(function() {
    'use strict';

    const translations = window.CURRENCY_ALERT_TRANSLATIONS || {
        'alert_set_success': 'Alert został ustawiony pomyślnie!',
        'recaptcha_expired': 'reCAPTCHA wygasła. Proszę ponownie potwierdzić.',
        'recaptcha_error': 'Wystąpił błąd reCAPTCHA. Spróbuj ponownie.',
        'complete_recaptcha': 'Proszę ukończyć weryfikację reCAPTCHA',
        'sending': 'Wysyłanie...',
        'confirm_notification': 'Czy chcesz ustawić powiadomienie?',
        'higher': 'wyższy',
        'lower': 'niższy',
        'average_rate_on': 'Kurs średni na',
        'than': 'niż'
    };

    let recaptchaVerified = false;
    let submitButton = null;
    let emailInput = null;
    let gdprCheckbox = null;
    let currentPopup = null;

    function showRecaptchaError(message) {
        if (!currentPopup) return;

        const recaptchaContainer = currentPopup.querySelector('.currency-alert-popup__recaptcha');
        if (recaptchaContainer) {
            const existingError = recaptchaContainer.querySelector('.currency-alert-popup__recaptcha-error');
            if (existingError) {
                existingError.remove();
            }

            const errorDiv = document.createElement('div');
            errorDiv.className = 'currency-alert-popup__recaptcha-error';
            errorDiv.textContent = message;

            recaptchaContainer.appendChild(errorDiv);

            setTimeout(() => {
                errorDiv.remove();
            }, 3000);
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        initCurrencyAlertPopup();
        initCurrencyPairSelector();
    });

    window.onRecaptchaSuccess = function(token) {
        recaptchaVerified = true;
        validateSubmitButton();

        const recaptchaContainer = document.querySelector('.currency-alert-popup__recaptcha');
        if (recaptchaContainer) {
            const errorDiv = recaptchaContainer.querySelector('.currency-alert-popup__recaptcha-error');
            if (errorDiv) {
                errorDiv.remove();
            }
        }
    };

    window.onRecaptchaExpired = function() {
        recaptchaVerified = false;
        disableSubmitButton();

        const popup = document.getElementById('currencyAlertPopup');
        if (popup && popup.classList.contains('is-active')) {
            showRecaptchaError(translations.recaptcha_expired);
        }
    };

    window.onRecaptchaError = function() {
        recaptchaVerified = false;
        disableSubmitButton();

        const popup = document.getElementById('currencyAlertPopup');
        if (popup && popup.classList.contains('is-active')) {
            showRecaptchaError(translations.recaptcha_error);
        }
    };

    function updatePopupContent(type, value, baseCurrency, targetCurrency) {
        const messageH3 = popup.querySelector('.currency-alert-popup__message h3');
        const messageP = popup.querySelector('.currency-alert-popup__message p');

        if (messageH3) {
            messageH3.textContent = translations.confirm_notification;
        }

        if (messageP) {
            const typeText = type === 'higher' ? translations.higher : translations.lower;
            const currencyPair = `${baseCurrency}/${targetCurrency}`;
            messageP.innerHTML = `${translations.average_rate_on} <strong>${currencyPair}</strong> ${typeText} ${translations.than} <span class="currency-alert-popup__rate">${value}</span>`;
        }
    }

    function initCurrencyPairSelector() {
        const currentPageCurrency = getCurrentPageCurrency();

        window.currentCurrencyPair = {
            base: currentPageCurrency || 'EUR',
            target: 'PLN'
        };

        const currencyTabs = document.querySelectorAll('.currency-rates__tab');
        currencyTabs.forEach(tab => {
            tab.addEventListener('click', function() {
                const newBaseCurrency = this.getAttribute('data-currency');
                if (newBaseCurrency) {
                    window.currentCurrencyPair.base = newBaseCurrency;
                    updateCurrencyPairDisplay();
                }
            });
        });

        updateCurrencyPairDisplay();
    }

    function getCurrentPageCurrency() {
        if (window.currentCurrency && window.currentCurrency.symbol && window.currentCurrency.symbol !== 'ALL') {
            return window.currentCurrency.symbol;
        }

        const activeTab = document.querySelector('.currency-rates__tab--active');
        if (activeTab) {
            const tabCurrency = activeTab.getAttribute('data-currency');
            if (tabCurrency) {
                return tabCurrency;
            }
        }

        const urlPath = window.location.pathname;
        const currencyMap = {
            'kurs-euro': 'EUR',
            'kurs-dolar-amerykanski': 'USD',
            'kurs-funt-brytyjski': 'GBP',
            'kurs-frank-szwajcarski': 'CHF',
            'kurs-korona-czeska': 'CZK',
            'kurs-korona-dunska': 'DKK',
            'kurs-korona-norweska': 'NOK',
            'kurs-korona-szwedzka': 'SEK',
            'kurs-jen-japonski': 'JPY',
            'kurs-dolar-kanadyjski': 'CAD'
        };

        for (const [slug, currency] of Object.entries(currencyMap)) {
            if (urlPath.includes(slug)) {
                return currency;
            }
        }

        return 'EUR';
    }

    function updateCurrencyPairDisplay() {
        const { base, target } = window.currentCurrencyPair;

        const baseCurrency = base || 'EUR';
        const targetCurrency = target || 'PLN';

        const currencyTabs = document.querySelectorAll('.currency-rates__tab');
        currencyTabs.forEach(tab => {
            const tabCurrency = tab.getAttribute('data-currency');
            if (tabCurrency === baseCurrency) {
                tab.classList.add('currency-rates__tab--active');
                tab.setAttribute('aria-selected', 'true');
            } else {
                tab.classList.remove('currency-rates__tab--active');
                tab.setAttribute('aria-selected', 'false');
            }
        });

        const alertTitlePair = document.querySelector('.currency-alert__title-pair');
        if (alertTitlePair) {
            alertTitlePair.textContent = `${baseCurrency}/${targetCurrency}`;
        } else {
            const alertTitle = document.querySelector('.currency-alert__title');
            if (alertTitle) {
                const titleText = alertTitle.querySelector('.currency-alert__title-text');
                if (titleText) {
                    alertTitle.innerHTML = titleText.outerHTML + ` <span class="currency-alert__title-pair">${baseCurrency}/${targetCurrency}</span>`;
                } else {
                    const currentText = alertTitle.textContent;
                    const baseText = currentText.split(/[A-Z]{3}/).shift() || 'Ustaw powiadomienie o kursie ';
                    alertTitle.textContent = `${baseText}${baseCurrency}/${targetCurrency}`;
                }
            }
        }
    }

    function initCurrencyAlertPopup() {
        const popup = document.getElementById('currencyAlertPopup');
        if (!popup) {
            return;
        }

        currentPopup = popup;

        const alertButtons = document.querySelectorAll('.currency-alert__button');
        const overlay = popup.querySelector('.currency-alert-popup__overlay');
        const cancelButton = popup.querySelector('.currency-alert-popup__btn--cancel');
        const form = popup.querySelector('.currency-alert-popup__form');

        submitButton = popup.querySelector('.currency-alert-popup__btn--submit');
        emailInput = popup.querySelector('#emailInput');
        gdprCheckbox = popup.querySelector('#gdprConsent');

        let currentAlertData = {
            type: null,
            value: null,
            baseCurrency: null,
            targetCurrency: null
        };

        disableSubmitButton();

        if (emailInput) {
            emailInput.addEventListener('input', validateSubmitButton);
            emailInput.addEventListener('blur', validateSubmitButton);
        }

        if (gdprCheckbox) {
            gdprCheckbox.addEventListener('change', validateSubmitButton);
        }

        alertButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                const buttonName = this.getAttribute('name');
                const alertType = buttonName.includes('higher') ? 'higher' : 'lower';

                const input = document.getElementById(`alert-${alertType}`);
                const alertValue = input ? input.value : '';

                if (!alertValue || alertValue.trim() === '') {
                    input.focus();
                    input.classList.add('error');
                    setTimeout(() => input.classList.remove('error'), 2000);
                    return;
                }

                const { base, target } = window.currentCurrencyPair || { base: 'EUR', target: 'PLN' };
                const baseCurrency = base || 'EUR';
                const targetCurrency = target || 'PLN';

                currentAlertData = {
                    type: alertType,
                    value: alertValue,
                    baseCurrency: baseCurrency,
                    targetCurrency: targetCurrency
                };

                updatePopupContent(alertType, alertValue, baseCurrency, targetCurrency);
                openPopup();
            });
        });

        const mobileForm = document.querySelector('.currency-alert__mobile-form');
        if (mobileForm) {
            mobileForm.addEventListener('submit', function(e) {
                e.preventDefault();

                const alertTypeInput = mobileForm.querySelector('input[name="alert_type"]');
                const alertType = alertTypeInput ? alertTypeInput.value : null;

                const alertValueInput = mobileForm.querySelector('input[name="alert_value"]');
                const alertValue = alertValueInput ? alertValueInput.value.trim() : '';

                if (!alertValue) {
                    if (alertValueInput) {
                        alertValueInput.classList.add('error');
                        alertValueInput.focus();
                        setTimeout(() => alertValueInput.classList.remove('error'), 2000);
                    }
                    return;
                }

                const { base, target } = window.currentCurrencyPair || { base: 'EUR', target: 'PLN' };
                const baseCurrency = base || 'EUR';
                const targetCurrency = target || 'PLN';

                currentAlertData = {
                    type: alertType,
                    value: alertValue,
                    baseCurrency: baseCurrency,
                    targetCurrency: targetCurrency
                };

                updatePopupContent(alertType, alertValue, baseCurrency, targetCurrency);
                openPopup();
            });
        }

        function updatePopupContent(type, value, baseCurrency, targetCurrency) {
            const messageH3 = popup.querySelector('.currency-alert-popup__message h3');
            const messageP = popup.querySelector('.currency-alert-popup__message p');

            if (messageH3) {
                messageH3.textContent = translations.confirm_notification;
            }

            if (messageP) {
                const typeText = type === 'higher' ? translations.higher : translations.lower;
                const currencyPair = `${baseCurrency}/${targetCurrency}`;
                messageP.innerHTML = `${translations.average_rate_on} <strong>${currencyPair}</strong> ${typeText} ${translations.than} <span class="currency-alert-popup__rate">${value}</span>`;
            }
        }

        function openPopup() {
            popup.classList.add('is-active');
            document.body.style.overflow = 'hidden';

            if (form) {
                form.reset();
            }

            if (typeof grecaptcha !== 'undefined') {
                grecaptcha.reset();
            }

            recaptchaVerified = false;
            disableSubmitButton();

            setTimeout(() => {
                if (emailInput) {
                    emailInput.focus();
                }
            }, 100);

            document.addEventListener('keydown', handleEscapeKey);
        }

        function closePopup() {
            popup.classList.remove('is-active');
            document.body.style.overflow = '';

            if (form) {
                form.reset();
            }

            if (typeof grecaptcha !== 'undefined') {
                grecaptcha.reset();
            }

            recaptchaVerified = false;
            disableSubmitButton();

            document.removeEventListener('keydown', handleEscapeKey);
        }

        function handleEscapeKey(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closePopup();
            }
        }

        if (overlay) {
            overlay.addEventListener('click', closePopup);
        }

        if (cancelButton) {
            cancelButton.addEventListener('click', function(e) {
                e.preventDefault();
                closePopup();
            });
        }

        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                if (!recaptchaVerified) {
                    showErrorMessage(translations.complete_recaptcha);
                    return;
                }

                if (!validateForm()) {
                    return;
                }

                const originalText = submitButton.textContent;
                submitButton.textContent = translations.sending;
                submitButton.disabled = true;

                const formData = {
                    email: emailInput.value,
                    gdprConsent: gdprCheckbox.checked,
                    alertType: currentAlertData.type,
                    alertValue: currentAlertData.value,
                    baseCurrency: currentAlertData.baseCurrency || 'EUR',
                    targetCurrency: currentAlertData.targetCurrency || 'PLN',
                    currencyPair: `${currentAlertData.baseCurrency || 'EUR'}/${currentAlertData.targetCurrency || 'PLN'}`,
                    'g-recaptcha-response': grecaptcha.getResponse()
                };

                const payload = new URLSearchParams({
                    saveExchangeNotificationData: '1',
                    Email: formData.email,
                    Currency: formData.baseCurrency,
                    Direction: formData.alertType === 'higher' ? 'Wzrost' : 'Spadek',
                    Rate: formData.alertValue
                });

                setTimeout(() => {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;

                    showSuccessMessage();

                    setTimeout(() => {
                        closePopup();

                        // Strzał do istniejącego endpointu /ajax z nowymi danymi
                        fetch('/ajax', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: new URLSearchParams({
                                'saveExchangeNotificationData': '1',
                                'Email': formData.email,
                                'Currency': formData.baseCurrency,
                                'Direction': formData.alertType === 'higher' ? 'Wzrost' : 'Spadek',
                                'Rate': formData.alertValue,
                            }).toString()
                        });
                    }, 2000);
                }, 1000);
            });
        }

        function validateForm() {
            let isValid = true;

            if (emailInput) {
                const emailValue = emailInput.value.trim();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailValue || !emailRegex.test(emailValue)) {
                    emailInput.classList.add('error');
                    isValid = false;
                } else {
                    emailInput.classList.remove('error');
                }
            }

            if (gdprCheckbox && !gdprCheckbox.checked) {
                gdprCheckbox.parentElement.classList.add('error');
                isValid = false;
            } else if (gdprCheckbox) {
                gdprCheckbox.parentElement.classList.remove('error');
            }

            return isValid;
        }

        function showSuccessMessage() {
            const content = popup.querySelector('.currency-alert-popup__content');
            if (content) {
                const successDiv = document.createElement('div');
                successDiv.className = 'currency-alert-popup__success';
                successDiv.innerHTML = `
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="#28a745"/>
                        <path d="M20 24L22.5 26.5L28 21" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p>${translations.alert_set_success}</p>
                `;
                content.appendChild(successDiv);

                setTimeout(() => {
                    successDiv.remove();
                }, 2000);
            }
        }

        function showErrorMessage(message) {
            const content = popup.querySelector('.currency-alert-popup__content');
            if (content) {
                const existingError = content.querySelector('.currency-alert-popup__error');
                if (existingError) {
                    existingError.remove();
                }

                const errorDiv = document.createElement('div');
                errorDiv.className = 'currency-alert-popup__error';
                errorDiv.innerHTML = `
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="#dc3545"/>
                        <path d="M16 16L32 32M16 32L32 16" stroke="white" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                    <p>${message}</p>
                `;

                content.insertBefore(errorDiv, content.firstChild);

                setTimeout(() => {
                    errorDiv.remove();
                }, 5000);
            }
        }

        const mainInputs = document.querySelectorAll('.currency-alert__input');
        mainInputs.forEach(input => {
            input.addEventListener('input', function() {
                this.classList.remove('error');
            });
        });
    }

    function validateSubmitButton() {
        if (!submitButton || !emailInput || !gdprCheckbox) return;

        const isEmailValid = emailInput.validity.valid && emailInput.value.trim() !== '';
        const isGdprChecked = gdprCheckbox.checked;
        const isRecaptchaValid = recaptchaVerified;

        if (isEmailValid && isGdprChecked && isRecaptchaValid) {
            enableSubmitButton();
        } else {
            disableSubmitButton();
        }
    }

    function enableSubmitButton() {
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('currency-alert-popup__btn--disabled');
            submitButton.style.opacity = '1';
            submitButton.style.cursor = 'pointer';
        }
    }

    function disableSubmitButton() {
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('currency-alert-popup__btn--disabled');
            submitButton.style.opacity = '0.5';
            submitButton.style.cursor = 'not-allowed';
        }
    }

    const additionalStyle = document.createElement('style');
    additionalStyle.textContent = `
        .currency-alert__input.error {
            border-color: #dc3545 !important;
            animation: shake 0.3s;
        }
        
        .currency-alert-popup__input.error {
            border-color: #dc3545 !important;
            box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.1);
        }
        
        .currency-alert-popup__checkbox-wrapper.error {
            color: #dc3545;
        }
        
        .currency-alert-popup__checkbox-wrapper.error .currency-alert-popup__checkbox-label {
            color: #dc3545;
        }
        
        .currency-alert-popup__btn--disabled {
            opacity: 0.5 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
            background: #6c757d !important;
        }
        
        .currency-alert-popup__btn--disabled:hover {
            transform: none !important;
            box-shadow: none !important;
        }
        
        .currency-alert-popup__success,
        .currency-alert-popup__error {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 32px;
            border-radius: 12px;
            text-align: center;
            box-shadow: 0 8px 32px rgba(0,0,0,0.15);
            z-index: 10;
            animation: fadeInScale 0.3s ease;
            border: 1px solid #e9ecef;
        }
        
        .currency-alert-popup__success {
            border-color: #28a745;
        }
        
        .currency-alert-popup__error {
            border-color: #dc3545;
        }
        
        .currency-alert-popup__success svg,
        .currency-alert-popup__error svg {
            margin-bottom: 16px;
        }
        
        .currency-alert-popup__success p {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #28a745;
        }
        
        .currency-alert-popup__error p {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #dc3545;
        }
        
        @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            75% { transform: translateX(5px); }
        }
        
        @keyframes fadeInScale {
            from {
                opacity: 0;
                transform: translate(-50%, -50%) scale(0.8);
            }
            to {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1);
            }
        }
        
        .currency-alert-popup__recaptcha-error {
            background: #f8d7da;
            color: #721c24;
            border: 1px solid #f1b0b7;
            border-radius: 6px;
            padding: 12px 16px;
            margin-top: 8px;
            font-size: 14px;
            text-align: center;
            animation: shake 0.3s;
        }
        
        .currency-alert-popup__btn--submit.currency-alert-popup__btn--disabled {
            background: #6c757d !important;
            color: #fff !important;
            opacity: 0.6 !important;
        }
    `;
    document.head.appendChild(additionalStyle);

})();